/* RESPONSIBLE TEAM: team-knowledge-foundations */

import { fragment } from 'ember-data-model-fragments/attributes';
import Fragment from 'ember-data-model-fragments/fragment';
import type CardStyle from '../styles/card';

export default class GlobalComponentStyle extends Fragment {
  @fragment('customization-options/styles/card') declare card: CardStyle;
}
